import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export default (muiTheme: ApplicationMuiTheme) => ({
    root: {
        width: '100%',
        height: '100%'
    },
    loader: {
        color: muiTheme?.app?.clientTheme.colors.buttons.primaryColorLighter || '#0096ff',
        fontSize: '20px',
        margin: '100px auto',
        width: '1em',
        height: '1em',
        borderRadius: '50%',
        position: 'relative' as const,
        textIndent: '-9999em',
        '-webkit-animation': '$load4 1.3s infinite linear',
        animation: '$load4 1.3s infinite linear',
        '-webkit-transform': 'translateZ(0)',
        '-ms-transform': 'translateZ(0)',
        transform: 'translateZ(0)'
    },
    '@keyframes load4': {
        '0%': {
            boxShadow: `0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, 
            -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0`
        },
        '100%': {
            boxShadow: `0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, 
            -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0`
        },
        '12.5%': {
            boxShadow: `0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, 
            -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em`
        },
        '25%': {
            boxShadow: `0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, 
            -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em`
        },
        '37.5%': {
            boxShadow: `0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, 
            -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em`
        },
        '50%': {
            boxShadow: `0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, 
            -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em`
        },
        '62.5%': {
            boxShadow: `0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, 
            -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em`
        },
        '75%': {
            boxShadow: `0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, 
            -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0`
        },
        '87.5%': {
            boxShadow: `0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, 
            -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em`
        }
    }
});